import React from 'react';

const WorksFor = () => {
  let types = [
    "Schools",
    "Nurseries",
    "Cubs",
    "Brownies",
    "Playgroups",
    "Vulnerable People",
    "Beach Safety",
    "Festivals",
    "More..."
  ]

  const listItems = types.map((name) =>
    <p key={name} className="wf-chip">{name}</p>
  );

  return (
    <div className="wf-container">
      <h2 className="vk-title wf-title">VizKidz works for...</h2>
        {listItems}
    </div>
  );
}

export default WorksFor;



// WEBPACK FOOTER //
// ./src/components/home/worksForPane.js